import rg4js from 'raygun4js';

if (process.env.raygun_api_key) {
    rg4js('apiKey', process.env.raygun_api_key);
    rg4js('enableCrashReporting', true);
}
